// export const groupLookup = (lookups = []) => {
//   return lookups.reduce((acc, lkp) => {
//     if (acc[lkp.lookupType]) {
//       acc[lkp.lookupType].push({
//         label: lkp.lookupLabel,
//         value: lkp.lookupCd,
//         leaveValue: lkp.lookupVal,
//       });
//     } else {
//       acc[lkp.lookupType] = [
//         {
//           label: lkp.lookupLabel,
//           value: lkp.lookupCd,
//           leaveValue: lkp.lookupVal,
//         },
//       ];
//     }

//     return acc;
//   }, {});
// };

export const groupLookup = (lookups = []) => {
  return lookups.reduce((acc, lkp) => {
    const lookupItem = {
      label: lkp.lookupLabel,
      value: lkp.lookupCd,
      leaveValue: lkp.lookupVal,
      sortOrderNbr: lkp.sortOrderNbr, // Include sortOrderNbr for sorting
    };

    if (acc[lkp.lookupType]) {
      acc[lkp.lookupType].push(lookupItem);
    } else {
      acc[lkp.lookupType] = [lookupItem];
    }

    return acc;
  }, {});
};

// Function to sort groups by sortOrderNbr
export const sortGroupedLookups = (groupedLookups) => {
  Object.keys(groupedLookups).forEach((key) => {
    groupedLookups[key].sort((a, b) => a.sortOrderNbr - b.sortOrderNbr);
  });
  return groupedLookups;
};

export function pairWithValue(array, payloadValue) {
  let values = "";
  if (payloadValue) {
    values = array?.find((obj) => {
      return obj.value === payloadValue;
    });
  }
  return values?.label;
}

export function pairWithLabels(array, payloadLable) {
  const key = array.find((obj) => {
    return obj.label === payloadLable;
  });
  return key.value;
}
